/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSplash.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Import scrollTrigger.js bundle
 */
import { actionToSplash } from "./scrollTrigger/scrollTrigger-splash";

/**
 * hintBrowser
 * will-changeを外す
 */
var willChangeItem = document.querySelectorAll(".hintBrowser");

function hintBrowser() {
	for (let i = 0; i < willChangeItem.length; i++) {
		willChangeItem[i].classList.remove("hintBrowser");
	}
}

/**
 * スプラッシュ
 */
const setSplash = () => {
	window.addEventListener("DOMContentLoaded", () => {
		setTimeout(() => {
			//urlパラメーターに?id=homeがある場合はスプラッシュを表示しない
			let url = new URL(window.location.href);
			let param = url.searchParams.get("id");
			if (param == "home") {
			} else {
				if (window.document.body.classList.contains("home")) {
					var $myWindow = "visited";
					let splash = document.getElementById("splash");

					if (window.name.indexOf($myWindow) != -1) {
						splash.classList.add("visited");
					} else {
						window.name = $myWindow;
						splash.classList.add("active");
					}
				} else {
					// splash.classList.add("visited");
				}
			}
			actionToSplash();
			hintBrowser();
		}, 1000);
	});
};

/**
 * ページ遷移アニメーション
 */
const anchorLinks = document.querySelectorAll('a:not([href^="#"]):not([href^="javascript:void(0);"]):not([target="_blank"]):not([href^="tel:"])');

anchorLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
        e.preventDefault(); // デフォルトのリンク動作をキャンセル
        const url = e.currentTarget.href; // リンク先のURL
        const mask = document.getElementById("mask"); // マスク要素を取得

        // マスクが存在する場合のみアニメーションを実行
        if (mask) {
            mask.classList.add("active"); // マスクを表示

            // マスクが表示された後、指定した時間だけ待ってから遷移
            setTimeout(() => {
                window.location.href = url; // URLに遷移
            }, 100); // 500ms 待つ（必要に応じて調整）
        } else {
            // マスクが存在しない場合は通常通りに遷移
            window.location.href = url;
        }

        return false;
    });
});


/**
 * ページ表示アニメーション（電子事業、フードトップのみ）
 */
document.addEventListener("DOMContentLoaded", () => {
    const mask = document.getElementById("page-mask");
    const content = document.getElementById("lower-top");

    // マスクが存在する場合にアニメーションを実行
    if (mask) {
        mask.classList.add("active"); // マスクを表示

        // マスクのアニメーションが終了した後、コンテンツを表示
        setTimeout(() => {
            content.classList.add("visible"); // コンテンツを表示
        }, 200); // 500ms 待つ（必要に応じて調整）
    } else {
        content.classList.add("visible"); // マスクがない場合、直接コンテンツを表示
    }
});






/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setSplash };
